export default __webpack_public_path__ + "static/media/pattern.a622be6a.png";